import * as React from 'react';
import { WebAPI } from '../../../../MedicareProAPI/API/WebAPI';
import StyledModal from '../../StyledModal';
import { UserRepository } from '../../../../MedicareProAPI/Repositories/User/UserRepository';
import { MultiSelectModal } from './MultiSelectModal';
import type { SelectMap } from '../../../Utilities/SelectMap';
import { MultiSelect } from './MultiSelect';

export interface UserSourceSelectProps {
  userAccessToken: string;
  userId: number;
  disabled?: boolean;

  onChange?: (userLeadStatus: string[]) => void;

  value: string[];
}

export const UserSourceSelect = (props: UserSourceSelectProps): React.JSX.Element => {
  const [userSources, setUserSources] = React.useState<any>(null);
  const [userSourcesLoading, setUserSourcesLoading] = React.useState<boolean>(false);

  const [value, setValue] = React.useState<string[]>(props.value);

  const webAPI = new WebAPI();
  webAPI.setAccessToken(props.userAccessToken);

  React.useEffect(() => {
    setUserSourcesLoading(true);

    webAPI.getIndsGrouped('ind_source', props.userId).then((response) => {
      setUserSourcesLoading(false);

      const options: SelectMap[] = [];

      if (response.data && response.data.length > 0) {
        for (const item of response.data) {
          options.push({
            value: item.field,
            label: item.field,
          });
        }
      }

      setUserSources(options);
    });
  }, []);

  return (
    <>
      <div>
        {userSourcesLoading === true && (
          <div className="alert small alert-info" role="alert">
            <i className="fas fa-spinner fa-spin ml-2"></i> Loading....
          </div>
        )}
        {userSourcesLoading === false && userSources && (
          <MultiSelectModal
            value={value}
            options={userSources}
            disabled={props.disabled}
            modalSaveButtonLabel="Save Changes"
            modalTitle="Select Sources"
            buttonSelectLabel="Choose Sources"
            buttonEditLabel="Edit Sources"
            onChange={(newValue) => {
              setValue(newValue);

              if (props.onChange) {
                props.onChange(newValue);
              }
            }}
          />
        )}
      </div>
    </>
  );
};
